export enum Method {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE'
}

export const isMutationMethod = (method: string): boolean =>
    [Method.POST, Method.PUT, Method.DELETE].includes(method.toUpperCase() as Method);

export enum ResponseCode {
    Ok = 200,
    Error = 400,
    PermissionDenied = 403,
    NothingFound = 404,
    SessionExpired = 600,
    InvalidToken = 623,
    Maintenance = 640
}

const RESOLVED_CODES = new Set<number>([ResponseCode.Ok, ResponseCode.NothingFound]);
export const isResolvedResponse = (code: number | undefined): boolean => {
    return code !== undefined && RESOLVED_CODES.has(code);
};

const SESSION_ERROR_CODES = new Set<number>([ResponseCode.SessionExpired, ResponseCode.InvalidToken]);
export const isSessionError = (code: number | undefined): boolean => {
    return code !== undefined && SESSION_ERROR_CODES.has(code);
};

export type RequestParams = Record<string, string | number | File | Blob | Array<any> | null | unknown>;
export interface ApiResponse<TData = unknown> {
    code: number;
    data: TData;
}
